// extracted by mini-css-extract-plugin
export default {"Toolbar":"sample-dealer-quota-detail_Toolbar__e4cEE"};